module.exports = __webpack_public_path__ + "images/emoji/iphone.e231169d18d3ba3dad66.png";